// extracted by mini-css-extract-plugin
module.exports = {"img":"about-me-module--img--3AszB","root":"about-me-module--root--1opKX"};